module.exports = __webpack_public_path__ + "static/logo-38ecae6860b8f26e2ebf2fb4e8b9effe.png";